import { StatusChipColor } from "components/StatusChip";
import { RuleSuggestionStatus } from "generated-graphql/graphql";

/**
 * Grid display status. Our DB keeps a 3-state review status; Linear owns the
 * engineering pipeline. Special-case only the endpoints (triage/completed/
 * canceled) and otherwise show Linear's own state name verbatim.
 */
export function deriveSuggestionStatus(
  status: RuleSuggestionStatus,
  linearStateName: string | null | undefined,
  linearStateType: string | null | undefined,
  linearIssueIdentifier: string | null | undefined
): { label: string; color: StatusChipColor } {
  switch (status) {
    case RuleSuggestionStatus.Open:
      return { label: "Needs review", color: "warning" };
    case RuleSuggestionStatus.Dismissed:
      return { label: "Dismissed", color: "default" };
    case RuleSuggestionStatus.Promoted: {
      // A claim with no ticket means the Linear call failed mid-promotion;
      // surface it distinctly so staff know to promote again.
      if (linearIssueIdentifier == null) {
        return { label: "Promotion incomplete", color: "warning" };
      }
      if (linearStateType === "completed") return { label: "Promoted", color: "success" };
      if (linearStateType === "canceled") return { label: "Ticket canceled", color: "error" };
      if (linearStateType === "triage" || linearStateType == null || linearStateName == null) {
        return { label: "Ticket created", color: "info" };
      }
      return { label: linearStateName, color: "info" };
    }
  }
}

export function confidenceColor(confidence: string | null | undefined): StatusChipColor {
  if (confidence === "high") return "success";
  if (confidence === "medium") return "warning";
  return "default";
}
